export default __webpack_public_path__ + "static/media/Background_00150.328cfa6c.png";